module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-11.dd846cb1.png";